import { omit } from '@myrealtrip/modash';

export const UTM_QUERY_KEYS = {
  utm_medium: 'utm_medium',
  utm_campaign: 'utm_campaign',
  utm_source: 'utm_source',
  utm_term: 'utm_term',
  utm_content: 'utm_content',
  contents_id: 'contents_id',
  n_ad_group: 'n_ad_group',
  n_ad: 'n_ad',
  n_campaign_type: 'n_campaign_type',
  n_keyword: 'n_keyword',
  n_keyword_id: 'n_keyword_id',
} as const;

export const UTM_COOKIE_KEYS = {
  ...omit(UTM_QUERY_KEYS, ['contents_id']),
  utm_date: 'utm_date',
  recent_utm_date: 'recent_utm_date',
  recent_utm_medium: 'recent_utm_medium',
  recent_utm_campaign: 'recent_utm_campaign',
  recent_utm_source: 'recent_utm_source',
  recent_utm_term: 'recent_utm_term',
  recent_utm_content: 'recent_utm_content',
  recent_n_ad_group: 'recent_n_ad_group',
  recent_n_ad: 'recent_n_ad',
  recent_n_campaign_type: 'recent_n_campaign_type',
  recent_n_keyword: 'recent_n_keyword',
  recent_n_keyword_id: 'recent_n_keyword_id',
  mrt_contents: 'mrt_contents',
} as const;

export const MARKETING_PARTNER_QUERY_KEYS = {
  mylink_id: 'mylink_id',
  t_scope: 't_scope',
} as const;

export const MARKETING_PARTNER_COOKIE_KEYS = {
  short_link_log: 'short-link-log',
} as const;
